module.exports = __webpack_public_path__ + "static/media/howpapa.8f1d6a15.png";